import {IEventsHub} from "./IEventsHub";
import {PubSubAbstract} from "../pubSub/PubSubAbstract";

export const EventsHub: IEventsHub = {
    menuControllerPathChange: new PubSubAbstract(),
};
